function oxgBriefingTypeFilterMenu(menu) {
  menu.addEventListener('change', ()=> {
    let currentUrl = new URL(window.location.href);
    let searchParams = new URLSearchParams(currentUrl.search);
    if ( menu.value == 'asset' || menu.value == 'campaign' ) {
      searchParams.set('briefing_type', menu.value);
      let newUrl = `${currentUrl.origin}${currentUrl.pathname}?${searchParams.toString()}`;
      window.location.href = newUrl;
    } else {
      searchParams.set('briefing_type', 'any');
      let newUrl = `${currentUrl.origin}${currentUrl.pathname}?${searchParams.toString()}`;
      window.location.href = newUrl;
    }
  })
}

function oxgBriefingOriginFilterMenu(menu) {
  let children = menu.querySelectorAll('.filter-button');
  if(!children) return
  console.log('children', children)
  Array.from(children).forEach(child => {
    child.addEventListener('click', (e)=> {
      e.preventDefault()
      let filterOption = child.getAttribute('data-filter')
      let targetUrl = new URL(child.href)
      let currentUrl = new URL(window.location.href);
      let searchParams = new URLSearchParams(currentUrl.search);
      searchParams.set('filter', filterOption);
      let newUrl = `${targetUrl.origin}${targetUrl.pathname}?${searchParams.toString()}`;
      window.location.href = newUrl;
    })
  })
}

document.addEventListener('DOMContentLoaded', () => {
  let briefingTypeFilter = document.getElementById('oxg-select-briefing-type')
  if(briefingTypeFilter) {
    oxgBriefingTypeFilterMenu(briefingTypeFilter)
  }
  let briefingOriginFilter = document.getElementById('oxg-select-briefing-origin')
  if(briefingOriginFilter) {
    oxgBriefingOriginFilterMenu(briefingOriginFilter)
  }
})